// src/App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { AboutPage } from "./pages/AboutPage";
import { ServicesPage } from "./pages/ServicesPage";
import { ProjectsPage } from "./pages/ProjectsPage";
import { ContactPage } from "./pages/ContactPage";
import { HomePage } from "./pages/HomePage";
import { BlogPost } from "./components/blog-post";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import { BlogPage } from "./pages/BlogPage";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { NotFoundPage } from "./components/NotFoundPage";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div>
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage landingPageData={landingPageData} />} />
          <Route path="/about" element={<AboutPage data={landingPageData.About} />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/portfolio" element={<ProjectsPage />} />
          <Route path="/contact" element={<ContactPage data={landingPageData.Contact} />} />
          <Route path="/blog" element={<BlogPage data={landingPageData.Blog}/>} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
};

export default App;